import emailjs from '@emailjs/browser';
import toast from 'react-hot-toast';

/**
 * Sends an order confirmation email using EmailJS
 * @param {Object} orderData - The order document data
 * @param {Object} config - siteConfig/payments configuration
 */
export const sendOrderConfirmation = async (orderData, config, generalConfig) => {
    const siteName = generalConfig?.siteName || "LB Books";
    const siteLogo = generalConfig?.siteLogo;
    // Basic validation of config - support both naming conventions
    const serviceId = config.emailServiceId || config.emailjsServiceId;
    const templateId = config.emailTemplateId || config.emailjsTemplateId;
    const publicKey = config.emailPublicKey || config.emailjsPublicKey;
    const enabled = config.emailEnabled !== undefined ? config.emailEnabled : config.emailjsEnabled;

    if (!enabled || !publicKey) {
        console.warn('Email confirmation skipped: Configuration missing.');
        return;
    }

    const templateParams = {
        site_name: siteName,
        site_logo: siteLogo,
        order_id: orderData.id,
        customer_name: orderData.customerName,
        customer_email: orderData.email,
        total_amount: `$${(orderData.total || 0).toFixed(2)}`,
        order_link: `${window.location.origin}/order/${orderData.id}`,
        items_summary: (orderData.items || []).map(item => `${item.quantity}x ${item.title}`).join(', ')
    };

    if (config.emailProvider === 'resend') {
        // Handled by Firebase Cloud Function backend for security
        console.log('Resend email will be sent by the backend.');
        return;
    }

    // Default EmailJS Logic
    try {
        emailjs.init(publicKey);

        // 1. Send to Customer
        await emailjs.send(
            serviceId,
            templateId,
            templateParams,
            { publicKey }
        );
        console.log('Order confirmation email sent to customer!');

        // 2. Send to Admin (Optional)
        if (config.adminEmailEnabled && config.adminEmail && config.adminTemplateId) {
            const adminParams = {
                ...templateParams,
                to_email: config.adminEmail,
            };
            await emailjs.send(
                serviceId,
                config.adminTemplateId,
                adminParams,
                { publicKey }
            );
            console.log('Order alert sent to admin!');
        }
    } catch (error) {
        console.error('FAILED to send email notifications:', error);
        toast.error(`Email notification failed: ${error.text || error.message || 'Check EmailJS Config'}`);
    }
};
